import Swiper from "swiper";
import { Navigation, EffectFade } from 'swiper/modules';

const archiveCarousel = document.querySelectorAll(".archive-carousel");

archiveCarousel.forEach((slider) => {
    const Carousel    = slider.querySelector(".swiper");
    const prevArrow   = slider.querySelector(".swiper-button-prev");
    const nextArrow   = slider.querySelector(".swiper-button-next");

    const mainSwiper = new Swiper(Carousel, {
        modules: [Navigation, EffectFade],
        slidesPerView: 1,
        centerInsufficientSlides: true,
        spaceBetween: 0,
        autoHeight: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        navigation: { nextEl: nextArrow, prevEl: prevArrow },
    });

    window.addEventListener('load', () => {
        mainSwiper.updateAutoHeight();
    });
});
